<template>
  <el-dialog
    v-model="visible"
    title="安装应用"
    width="420px"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
  >
    <div style="text-align: center; padding: 20px 0;">
      <el-icon :size="64" color="#409EFF" style="margin-bottom: 16px;">
        <Download />
      </el-icon>
      <h3 style="margin-bottom: 12px; font-size: 18px;">安装恒庐订单管理系统</h3>
      <p style="color: #909399; font-size: 14px; line-height: 1.6; margin-bottom: 8px;">
        将应用添加到主屏幕，享受更快的访问速度和离线使用体验
      </p>
      <ul style="text-align: left; color: #606266; font-size: 13px; margin: 16px 0; padding-left: 20px;">
        <li>更快的加载速度</li>
        <li>离线访问功能</li>
        <li>类似原生应用的体验</li>
      </ul>
    </div>
    <template #footer>
      <div style="text-align: center;">
        <el-button @click="handleCancel">稍后再说</el-button>
        <el-button type="primary" @click="handleInstall" :loading="installing">
          立即安装
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { Download } from '@element-plus/icons-vue'
import { usePWA } from '@/composables/usePWA'

const visible = ref(false)
const installing = ref(false)
const { canInstall, install, isInstalled } = usePWA()

// 检查是否应该显示安装提示
const checkShouldShow = () => {
  // 如果已安装，不显示
  if (isInstalled.value) {
    return false
  }
  
  // 如果支持安装，显示提示
  if (canInstall.value) {
    // 检查本地存储，避免频繁提示
    const lastPromptTime = localStorage.getItem('pwa-install-prompt-time')
    const now = Date.now()
    const oneDay = 24 * 60 * 60 * 1000
    
    // 如果一天内已经提示过，不再提示
    if (lastPromptTime && (now - parseInt(lastPromptTime)) < oneDay) {
      return false
    }
    
    return true
  }
  
  return false
}

// 处理安装
const handleInstall = async () => {
  installing.value = true
  try {
    const accepted = await install()
    if (accepted) {
      visible.value = false
      // 可以显示成功提示
      console.log('PWA安装成功')
    } else {
      // 用户拒绝了安装
      console.log('用户取消了PWA安装')
    }
    // 记录提示时间
    localStorage.setItem('pwa-install-prompt-time', Date.now().toString())
  } catch (error) {
    console.error('安装失败:', error)
  } finally {
    installing.value = false
  }
}

// 处理取消
const handleCancel = () => {
  visible.value = false
  // 记录提示时间，避免立即再次提示
  localStorage.setItem('pwa-install-prompt-time', Date.now().toString())
}

// 监听安装提示事件
const handleBeforeInstallPrompt = () => {
  // 延迟显示，给用户一些时间浏览页面
  setTimeout(() => {
    if (checkShouldShow()) {
      visible.value = true
    }
  }, 3000) // 3秒后显示
}

onMounted(() => {
  // 监听安装提示事件
  window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
  
  // 如果已经可以安装，直接检查
  if (canInstall.value) {
    handleBeforeInstallPrompt()
  }
})

onUnmounted(() => {
  window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
})
</script>

<style scoped>
</style>

